import React, { Component, useState, useEffect } from 'react';
import { connect, } from 'react-redux';
import { Container, Spinner, Row, Col, Form, } from 'react-bootstrap';
import Lottie from "react-lottie";
import { withRouter } from '../withRouter';
import { getStateCallbacks } from "colyseus.js";
import { joinRoom, reconnectToRoom } from 'actions/room';
import { BiLeftArrowAlt } from "react-icons/bi";
import * as Sentry from "@sentry/react";
import { APP_TYPES } from "constants/AppTypes"
import Game from "components/Games/Game"

import styles from "components/Room/Play.module.scss";
import DotLoader from 'components/Utlility/DotLoader';

import GameList from "constants/GameList";
import GameMenu from "./GameMenu";
import GameVote from "../Games/GameVote"

import BuyForLobbyModal from 'components/BuyForLobbyModal/BuyForLobbyModal';
import UpsellModal from 'components/Modals/UpsellModal/UpsellModal';

import {iosTransaction, androidTransaction} from 'services/AppTransactions';

const upsellBrackets = [1, 5, 10, 20];

class Play extends Component {
    static displayName = Play.name;

    constructor(props) {
        super(props);

        this.state = {
            roomId: "",
            sessionId: "",
            nickname: "",
            showAvatars: false,
            chosenAvatar: 0,
            player: null,
            selectedGame: null,
            hostUser: null,
            userCalledPurchase: false,
            gotLocationPing: true,
            connectionIssue: false,
            isInApp: false,
            showPurchasedModal: false,
            newGamePurchased: null,
        };
        this.buyForLobbyModal = React.createRef();
    }

    componentDidMount() {
        if (this.props.room.roomOpen) {
            if (this.props.room.isHost) {
                return setTimeout(() => this.props.navigate("/lobby"));
            } else {
                this.setRoomVars();
            }
        } else {
            const queryParams = new URLSearchParams(window.location.search);
            const isRoku = queryParams.has("roku")
            if (queryParams.has("qrCode")) {
                return setTimeout(() => this.props.navigate(`/join?qrCode=${queryParams.get("qrCode")}${isRoku ? "&roku=true" : ""}`));
            } else if (queryParams.has("token")) {
                this.props.reconnectToRoom(queryParams.get("token")).then((res) => {
                    if (res.Status === "Error") {
                        return setTimeout(() => this.props.navigate(`/join${isRoku ? "roku=true" : ""}`));
                    }
                })
            } else if (queryParams.has("deviceType")) {
                const deviceType = queryParams.get("deviceType");
                if (deviceType === 'ios') this.setState({ deviceType: 'ios' });
            } else {
                return setTimeout(() => this.props.navigate(`/join${isRoku ? "roku=true" : ""}`));
            }
        }
        //console.log("avaiable games:", this.props.room.roomState.availableGames, "from room state: ", this.props.room.roomState, "and room: ", this.props.room.room)
        this.checkForMobileDevice();

        if (typeof window !== "undefined") {
            this.setupIOSBridge();
            this.setupAndroidBridge();
        }
    }

    setupIOSBridge() {
        window.onPurchaseComplete = (status, jws) => {
            if (status === "success" && jws) {
                alert('Purchase Successful! You can now play the game.');
                const hostUserEmail = this.state.hostUser || "";
                const payload = {
                    SignedTransactionJws: jws,
                    AutoRedeemUsername: hostUserEmail
                };

                iosTransaction(payload, this.onPurchased);
            } else if (status === "success") {
                alert('Purchase Successful! You can now play the game.');
                this.onPurchased();
            } else {
                alert('Purchase Failed or Cancelled. Please try again later.');
            }
        };
    }

    setupAndroidBridge() {
        window.onAndroidPurchaseVerified = (productId, purchaseToken, email) => {
            //console.log("✅ Purchase received from Android:");
            //console.log("   Product ID:", productId);
            //console.log("   Token:", purchaseToken);

            this.sendTestLogToAndroid(`Purchase received from Android: Product ID: ${productId}, Token: ${purchaseToken}, Email: ${email}`)

            const payload = {
                SKU: productId,
                purchaseToken: purchaseToken,
                AutoRedeemUsername: email
            };

            androidTransaction(payload, this.onPurchased)
        };
    }

    sendTestLogToAndroid(log) {
        if (window.AndroidBridge?.androidAppReady) {
            window.AndroidBridge.androidAppReady(log);
        }
    }

    checkForMobileDevice() {
        if (window.webkit?.messageHandlers?.appReady) {
            window.webkit.messageHandlers.appReady.postMessage("ready")
            this.registerIosCallbacks();
        }
        if (window.AndroidBridge?.androidAppReady) {
            window.AndroidBridge.androidAppReady("ready");
            this.registerAndroidCallbacks();
            this.setState({ isInApp: true })
        }
    }

    registerAndroidCallbacks = () => {
        window.onAndroidReady = () => {
            this.setState({ isInApp: true })
        }
    }

    registerIosCallbacks = () => {
        window.onNativeReady = () => {
            if (window.webkit?.messageHandlers?.logHandler) {
                window.webkit.messageHandlers.logHandler.postMessage(`SENT BACK TO CLIENT`)
                this.setState({ isInApp: true })
            }
        }
    }



    decodeHostUserToken(token) {
        var user = this.parseJwt(token)
        this.setState({ hostUser: user })
    }

    parseJwt(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }

    setRoomVars() {
        this.setState({
            roomId: this.props.room.roomId,
            sessionId: this.props.room.sessionId,
        });
        this.updateToken(this.props.room.room.reconnectionToken);
        this.setTags();
        this.startLocationChecks();
        this.decodeHostUserToken(this.props.room.roomState.accessToken);
        this.setUpsellItem();
    }

    setUpsellItem() {
        const lastGameId = this.props.room.roomState.lastGameId;
        console.log("Last Game Id : ", lastGameId);
        if (!lastGameId || lastGameId.length === 0) {
            this.setState({ upsellItem: null });
            return;
        }

        // Collect all item IDs we already have
        let possibleIds = GameList.find((g) => g.gameId === lastGameId).gameUpsellIds;
        console.log("Possible Ids : ", possibleIds);

        // Filter out ones already in items
        possibleIds = possibleIds.filter(id => !this.props.room.roomState.availableGames.includes(id));
        console.log("Possible Ids 2: ", possibleIds);

        if (possibleIds.length === 0) {
            this.setState({ upsellItem: null });
            return;
        }

        // Convert to actual game objects
        let possibleGames = GameList.filter(game => possibleIds.includes(game.gameId) && game.enabled);
        console.log("Possible games: ", possibleGames);

        if (possibleGames.length === 0) {
            this.setState({ upsellItem: null });
            return;
        }

        // Pick a random game
        const randomGame = possibleGames[Math.floor(Math.random() * possibleGames.length)];
        this.setState({ upsellItem: randomGame });
        return;
    }

    upsellModalCallback = () => {
        this.setState({ upsellItem: null });
        localStorage.setItem(`${this.props.room.roomId}-${this.props.room.roomState.gamesPlayed}-upsell`, true);
    }

    upsellOverrideCallback = () => {
        this.onBuyGameForLobby(this.state.upsellItem);
        this.upsellModalCallback()
    }

    updateToken(token) {
        var url = new URL(window.location.href);

        try {
            window.history.replaceState(null, null, (url.pathname) + (`?token=${token}`));
        } catch (e) {
            console.warn(e)
        }
    }


    setTags() {
        const queryParams = new URLSearchParams(window.location.search);

        const token = queryParams.get("token");
        Sentry.setTag('isPlayer', true);

        if (token) {
            const [roomId, reconnectToken] = token.split(':');
            Sentry.setTag('roomId', roomId);
            Sentry.setTag('reconnectToken', reconnectToken);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.room.roomOpen === false && prevProps.room.roomOpen === true) {
            const queryParams = new URLSearchParams(window.location.search);
            const isRoku = queryParams.has("roku")
            this.props.navigate(`/join${isRoku ? "roku=true" : ""}`);
        } else if (this.props.room.roomOpen === true && prevProps.room.roomOpen === false) {
            this.setRoomVars();
        } else if (this.state.isInApp && this.state.BuyForLobbyGame && this.state.userCalledPurchase === true) {
            if (window.webkit?.messageHandlers) {
                this.triggerIOSPurchase(this.state.BuyForLobbyGame);
            } else if (window.AndroidBridge?.purchaseGame) {
                this.triggerAndroidPurchase(this.state.BuyForLobbyGame);
            }
            this.setState({ userCalledPurchase: false })
        } else if (this.state.roomId !== "" && this.state.userCalledPurchase && this.state.isInApp) {
            this.enableIOSPurchases();
        } else if (this.props.room.roomState.availableGames !== prevProps.room.roomState.availableGames) {
            this.getNewestGame(this.props, prevProps)
        }
    }

    getNewestGame = (props, prevProps) => {
        const newGame = props.room.roomState.availableGames.find(gameId =>
            !prevProps.room.roomState.availableGames.includes(gameId)
        );

        if (newGame) {
            const game = GameList.find(g => g.gameId === newGame);
            if (game) {
                this.setState({ newGamePurchased: game, showPurchasedModal: true });
            }
        }
    }

    componentWillUnmount() {

        if (window.onPurchaseComplete) {
            window.onPurchaseComplete = null;
        }

        if (window.onAndroidPurchaseVerified) {
            window.onAndroidPurchaseVerified = null;
        }

    }


    enableIOSPurchases() {
        if (window.webkit?.messageHandlers?.enablePurchases) {
            window.webkit.messageHandlers.enablePurchases.postMessage();
        }
    }


    triggerIOSPurchase(game) {
        let gameID = game.iosGameID || game.gameId;
        if (window.webkit?.messageHandlers.logHandler) {
            window.webkit.messageHandlers.logHandler.postMessage(`HOST: ${JSON.stringify(this.state.hostUser)}`);
        }

        if (window.webkit?.messageHandlers.purchaseHandler) {
            window.webkit.messageHandlers.purchaseHandler.postMessage({
                productID: gameID,
                hostUser: JSON.stringify(this.state.hostUser)
            });
        } else {
            alert('In-app purchases are not available')
            this.setState({ BuyForLobbyGame: null })
        }
    }

    triggerAndroidPurchase(game) {
        let gameID = game.androidGameID || null;
        if (window.AndroidBridge?.purchaseGame) {
            const payload = JSON.stringify({ productID: gameID, hostUser: JSON.stringify(this.state.hostUser) })
            window.AndroidBridge.purchaseGame(payload);
        } else {
            alert('In-app purchases are not available')
            this.setState({ BuyForLobbyGame: null })
        }
    }

    onChangeNickname = (e) => {
        const re = /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/;
        const nickname = e.target.value.toUpperCase();
        if (nickname === '' || re.test(nickname)) {
            this.setState({ nickname });
        }
    };


    startLocationChecks() {
        if (this.props.room.roomOpen) {
            this.props.room.room.send("location_check", { gameId: "lobby", });

            this.props.room.room.onMessage("location_confirmed", (message) => {
                console.log("location_confirmed", "received on", this.props.room.room.name, message);
                this.setState({ gotLocationPing: true, });
            });
        }
        this.locationCheckInterval = setInterval(() => {
            if (this.props.room.roomOpen) {
                if (this.state.gotLocationPing) {
                    this.setState({ gotLocationPing: false, connectionIssue: false, });
                } else {
                    this.setState({ connectionIssue: true, });
                }
                this.props.room.room.send("location_check", { gameId: "lobby", });
            }
        }, 10000);
    }

    getActivePlayer() {
        return this.props.room.players.find(x => x.id === this.props.room.sessionId);
    }

    getAvatarList() {
        let arr = [];
        const player = this.getActivePlayer();
        const currentAvatar = player.avatar;
        
        this.props.room.avatarList.forEach((value, key) => {
            if (value.isActive) {
                arr.push(<Col className={styles.col}>
                    <div className={`${styles.avatar} ${this.state.chosenAvatar === value.id && !value.inUse && styles.selected} ${currentAvatar === value.src && styles.applied}`}
                        onClick={() => this.chooseAvatar(value.id)}
                    >
                        {
                            value.inUse && currentAvatar !== value.src ?
                                <img className={`${styles.potato} ${styles.fade}`} src={value.src} alt="avatar" />
                                :
                                <img className={`${styles.potato}`} src={value.src} alt="avatar" />
                        }
                    </div>
                </Col>);
            }
        });
        return arr;
    }

    chooseAvatar(id) {
        this.setState({ chosenAvatar: id });
        this.props.room.room.send("update_avatar", { avatarId: id, });
    }

    applyNameAndAvatar = (e) => {
        e.preventDefault();

        window.scrollTo(0, 0);
        this.setState({ showAvatars: false });
        localStorage.setItem("nickname", this.state.nickname);
        this.props.room.room.send("update_avatar", { avatarId: this.state.chosenAvatar, nickName: this.state.nickname, });
    }


    voteForGame = (game) => {
        this.props.room.room.send("game_vote", { gameId: game.gameId });
    }

    loadGameMenu = (game) => {
        this.setState({ selectedGame: game });
    }

    closeGameMenu = () => {
        this.setState({ selectedGame: null });
    }

    leaveRoom = (id) => {
        this.props.room.room.leave(true);
    }

    showAvatars = () => {
        window.scrollTo(0, 0);
        let player = this.getActivePlayer();
        this.setState({ showAvatars: true, nickname: player.name, });
    }

    refreshGames = () => {
        this.setState({ refreshingGames: true, refreshCooldown: 10 });
        this.props.room.room.send("refresh_lobby_games", {});

        const cooldown = setInterval(() => {
            const cooldownTime = this.state.refreshCooldown - 1;
            this.setState({ refreshCooldown: cooldownTime });
            if (cooldownTime === 0) {
                this.setState({ refreshingGames: false });
                clearInterval(cooldown);
            }
        }, 1000);
    }

    onBuyGameForLobby = (game) => {
        this.setState({ BuyForLobbyGame: game, userCalledPurchase: true });
    }

    onPurchased = () => {
        //console.log("on purchased hit ")
        this.sendTestLogToAndroid("onPurchased called from Play.js")
        window.scrollTo(0, 0);
        this.setState({ BuyForLobbyGame: null, purchaseTestDebug: true });
        this.refreshGames();
    }

    isDev() { return !process.env.REACT_APP_ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT === 'development' }

    renderBuyMoreGames() {
        const missingGames = GameList.filter(g => (g.enabled || this.isDev()) && !this.props.room.roomState.availableGames?.find((y) => g.gameId === y) && g.supportedPlatforms.includes(this.props.room.roomState.platform));

        if (missingGames.length <= 0) return;

        if (this.props.room.roomState.platform === APP_TYPES.FIRE_TV) return;
        
        return <React.Fragment>
            <h2>Add Games</h2>
            <Row className={`${styles.buyMoreList}`}>
                {
                    missingGames.map((g, i) => {
                        if (!g) return null;
                        return <Col key={g.gameId} md={12} sm={12} xs={12} style={{ padding: "1vh" }}>
                            <Game game={g} key={g.gameId}
                                buyNowText="Buy Now and Play"
                                onClickOverride={this.onBuyGameForLobby}
                                onBuyNow={this.onBuyGameForLobby}
                                showBuyNow={true}
                                isInApp={this.state.isInApp}
                                hostUser={this.state.hostUser} />
                        </Col>
                    })
                }
            </Row>
        </React.Fragment>
    }

    render() {
        const primaryPlayer = this.props.room.players?.find(p => p.primaryPlayer)
        const availableGamesData = GameList.filter(g => this.props.room.roomState.availableGames?.find((y) => g.gameId === y) /*&& g.supportedPlatforms.includes(this.props.room.roomState.platform)*/);
        const player = this.getActivePlayer();

        const gamesPlayed = this.props.room.roomState.gamesPlayed;
        const matchedUpsellBracket = upsellBrackets.find(x => x === gamesPlayed);
        const showUpsell = matchedUpsellBracket && !localStorage.getItem(`${this.props.room.roomId}-${gamesPlayed}-upsell`) && this.state.upsellItem && player.primaryPlayer;

        const limitAccessFireTv = this.props.room?.roomState?.platform === APP_TYPES.FIRE_TV || this.props.devices.limitAccessFireTv;

        return (
            <div className={styles.pageWrap}>
                <Container>
                    {showUpsell && <UpsellModal upsellItem={this.state.upsellItem} callback={this.upsellModalCallback} purchaseCallback={this.upsellOverrideCallback} overrideText={"BUY NOW"}></UpsellModal>}
                    {
                        player != null && this.props.room.roomOpen ?
                            <Container className="text-center position-relative" style={{ maxWidth: "600px" }}>
                                {
                                    this.state.connectionIssue &&
                                    <div className={styles.connectionIssueContainer}>
                                        <div className={styles.connectionText}>There might be an issue with your connection...<br />Click below to refresh!</div>
                                        <div className={styles.refreshButton} onClick={() => window.location.reload()}>&#x21bb;</div>
                                    </div>
                                }
                                {
                                    this.state.showAvatars ?
                                        <React.Fragment>
                                            <Row>
                                                <h2>Pick your avatar</h2>
                                            </Row>
                                            <Row className={`${styles.avatarList} row-cols-4`}>
                                                {
                                                    this.getAvatarList()
                                                }
                                            </Row>
                                            <Row>
                                                <Form className="d-flex flex-column" onSubmit={this.applyNameAndAvatar}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className={styles.nickName}>Nickname</Form.Label>
                                                        <Form.Control type="text" autoComplete="off" required value={this.state.nickname.toLowerCase() === "player" ? "" : this.state.nickname} placeholder="Enter Nickname" style={{ textTransform: "uppercase" }} maxLength={10} minLength={2} onChange={this.onChangeNickname} />
                                                    </Form.Group>

                                                    <button type="submit" className={styles.button}>Confirm</button>
                                                </Form>
                                            </Row>
                                        </React.Fragment>
                                        :
                                        <React.Fragment>

                                            <div className={styles.topSection}>
                                                <div className={styles.pickedTato}>
                                                    <div className={styles.tato}>
                                                        <img style={{ width: "100%", height: "100%", padding: "5%", objectFit: "contain" }} src={player.avatar} alt="avatar" />
                                                    </div>
                                                    <p className={`${player.name.length >= 6 ? player.name.length >= 9 ? styles.smaller : styles.small : ""}`}>{player.name}</p>
                                                </div>

                                                <div className={styles.playerControl} >
                                                    <button className={`${styles.button} ${styles.small}`} onClick={() => this.showAvatars()}>Change Me</button>
                                                    {
                                                        !limitAccessFireTv &&
                                                        <button onClick={this.leaveRoom} className={`${styles.button} ${styles.alternate} ${styles.small}`}><BiLeftArrowAlt />Leave</button>
                                                    }
                                                </div>
                                            </div>

                                            {
                                                player.primaryPlayer ?
                                                    <React.Fragment>
                                                        <Row>
                                                            <h2>You're the VIP!</h2>
                                                            <p>As you joined first you get to<br /> choose the game.</p>
                                                        </Row>
                                                        <Row className={styles.voteForGames}>
                                                            {
                                                                this.props.room.roomState.availableGames.length === 0 ?
                                                                    <h3 className={styles.noGamesText} >No games</h3>
                                                                    : availableGamesData.map((g, i) => {
                                                                        return <Col key={g.gameId} md={6} sm={6} xs={6} style={{ padding: "1vh" }}>
                                                                            <GameVote game={g} clickEvent={this.loadGameMenu} showVotes={true} supported={g.supportedPlatforms.includes(this.props.room.roomState.platform)} />
                                                                        </Col>
                                                                    })
                                                            }
                                                            <button className={`${styles.refreshLobbyGamesButton} ${styles.button} ${styles.small}`} onClick={this.refreshGames} disabled={this.state.refreshingGames}> Refresh Lobby {this.state.refreshCooldown > 0 && this.state.refreshCooldown + "s"}</button>
                                                        </Row>
                                                    </React.Fragment>
                                                    :
                                                    <React.Fragment>
                                                        <Row>
                                                            <h2>{primaryPlayer?.name} is the VIP!</h2>
                                                            <p>Vote for which game<br /> you want to play.</p>
                                                        </Row>
                                                        <Row className={styles.voteForGames}>
                                                            {
                                                                this.props.room.roomState.availableGames.length === 0 ?
                                                                    <h3 className={styles.noGamesText}>No games</h3>
                                                                    : availableGamesData.map((g, i) => {
                                                                        return <Col md={6} sm={6} xs={6} style={{ padding: "1vh" }}>
                                                                            <GameVote game={g} selected={player.gameVote === g.gameId} clickEvent={this.voteForGame} supported={g.supportedPlatforms.includes(this.props.room.roomState.platform)} />
                                                                        </Col>
                                                                    })
                                                            }
                                                        </Row>
                                                    </React.Fragment>
                                            }
                                            {this.props.room.roomState.availableGames.length < GameList.length && this.renderBuyMoreGames()

                                            }

                                        </React.Fragment>
                                }
                                {
                                    this.state.selectedGame &&
                                    <GameMenu game={this.state.selectedGame} closeGameMenu={this.closeGameMenu} isMobile={true} supported={this.state.selectedGame.supportedPlatforms.includes(this.props.room.roomState.platform)} />
                                }
                                {
                                    !limitAccessFireTv &&
                                    <button onClick={this.leaveRoom} className={`${styles.button} ${styles.alternate} ${styles.small}`}><BiLeftArrowAlt />Leave</button>
                                }
                            </Container>
                            :
                            <Container style={{ justifyContent: "center", alignItems: "center", padding: "5vh", display: "flex", position: "absolute", top: 0, bottom: 0 }}>
                                <DotLoader size="medium" variant="light" />
                            </Container>
                    }
                </Container>

                {this.state.BuyForLobbyGame &&
                    <>
                        {
                            this.state.isInApp === true ?
                                <></>
                                :
                                <BuyForLobbyModal
                                    game={this.state.BuyForLobbyGame}
                                    hostUser={this.state.hostUser}
                                    onPurchased={this.onPurchased}
                                    onClose={() => { this.setState({ BuyForLobbyGame: null }); }}
                                />
                        }
                    </>
                }
                {
                    this.state.showPurchasedModal &&
                    <>
                        <PurchasedModal state={this.state} closeModal={() => this.setState({ showPurchasedModal: false })} />
                    </>
                }
            </div>
        );
    }
}


const PurchasedModal = ({ state, closeModal }) => {
    const [newGame, setNewGame] = useState(null)

    useEffect(() => {
        if (state.newGamePurchased && state.newGamePurchased !== null) {
            setNewGame(state.newGamePurchased)
        }
    }, [state.newGamePurchased])


    const customGameStyles = {
        backgroundColor: newGame.meta.storeAccentColour,
        backgroundImage: `url(${newGame.meta.storeBackground})`,
        gameLogoImage: `url(${newGame.meta.storeLogo})`,
    }

    const returnDoubleText = (text) => {
        return (
            <div className={styles.doubleTextContainer}>
                <h1 className={styles.doubleTextTop}>{text}</h1>
                <h1 className={styles.doubleTextBottom}>{text}</h1>
            </div>
        )
    }

    return (
        newGame !== null &&
        <div className={styles.purchasedModalContainer} style={customGameStyles}>

            {returnDoubleText("THANK YOU FOR YOUR PURCHASE!")}
            <img src={newGame.meta.cardLogo} className={styles.purchasedModalGameLogo} />
            <img src={newGame.meta.previewImages.desktop1} className={styles.purchaseModalPreviewImage} style={{ border: `10px solid ${newGame.meta.storeAccentColour}` }} />
            <button onClick={() => closeModal()} className={styles.purchasedModalPlayButton}>Let's Play!</button>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        room: state.room,
        devices: state.devices,
    };
}


const mapDispatchToProps = (dispatch) => {
    return {
        joinRoom: (roomId, options) => {
            return dispatch(joinRoom(roomId, options))
        },
        reconnectToRoom: (token) => {
            return dispatch(reconnectToRoom(token))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Play));
